export const PROVINCES = [
  { code: "ON", name: "Ontario" },
  { code: "BC", name: "British Columbia" },
  { code: "AB", name: "Alberta" },
  { code: "SK", name: "Saskatchewan" },
  { code: "MB", name: "Manitoba" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NB", name: "New Brunswick" },
  { code: "PE", name: "Prince Edward Island" },
];

export const EDUCATION_OPTIONS = [
  { value: "none", label: "Less than secondary" },
  { value: "secondary", label: "Secondary / high school diploma" },
  { value: "one_year", label: "One-year post-secondary" },
  { value: "two_year", label: "Two-year post-secondary" },
  { value: "bachelor", label: "Bachelor's degree (3+ years)" },
  { value: "two_or_more", label: "Two or more credentials (one 3+ years)" },
  { value: "masters", label: "Master's degree" },
  { value: "doctoral", label: "Doctoral (PhD)" },
];

export const TEER_OPTIONS = [
  { value: 0, label: "TEER 0 — Management" },
  { value: 1, label: "TEER 1 — University degree jobs" },
  { value: 2, label: "TEER 2 — College / supervisory" },
  { value: 3, label: "TEER 3 — Training / experience" },
  { value: 4, label: "TEER 4 — Some secondary / training" },
  { value: 5, label: "TEER 5 — Short work demonstration" },
];

export const FRENCH_OPTIONS = [
  { value: 0, label: "No French / below CLB 4" },
  { value: 4, label: "CLB 4" },
  { value: 5, label: "CLB 5" },
  { value: 6, label: "CLB 6" },
  { value: 7, label: "CLB 7" },
  { value: 8, label: "CLB 8" },
  { value: 9, label: "CLB 9" },
  { value: 10, label: "CLB 10+" },
];

export const STATUS_META = {
  eligible: { label: "Eligible", color: "#166534", bg: "#F0FDF4", border: "#BBF7D0" },
  potentially_eligible: { label: "Potentially Eligible", color: "#9A3412", bg: "#FFFBEB", border: "#FDE68A" },
  not_eligible: { label: "Not Eligible", color: "#991B1B", bg: "#FEF2F2", border: "#FECACA" },
};

export const PROVINCE_COLORS = {
  ON: "#1D4ED8", BC: "#047857", AB: "#B45309", SK: "#7C3AED",
  MB: "#0E7490", NS: "#BE123C", NB: "#4338CA", PE: "#9D174D",
};

export const EMPTY_PROFILE = {
  age: 30,
  maritalStatus: "single",
  spouseAccompanying: false,
  education: "bachelor",
  eduInCanada: false,
  siblingInCanada: false,
  testType: "ielts",
  language: { listening: "", reading: "", writing: "", speaking: "" },
  frenchCLB: 0,
  frenchTest: "clb",
  connectionTypes: {},
  tradeCertificate: false,
  french: {},
  foreignExp: 3,
  canadianExp: 0,
  occupationTitle: "",
  nocCode: "",
  noc_teer: 1,
  occupationInDemand: false,
  jobOffer: false,
  jobOfferProvince: "",
  jobOfferTeer: -1,
  provincialConnection: [],
  funds: 15000,
  spouse: { education: "bachelor", clb: 0, canadianExp: 0, testType: "clb", language: {} },
  jobOfferWage: "",
  eduProvince: "",
  jobOfferMonths: 0,
  jobOfferRegion: "",
  legalStatus: "none",
  canadianEarnings: "",
};

export const LEGAL_STATUS_OPTIONS = [
  { value: "none", label: "Outside Canada / no permit" },
  { value: "work_permit", label: "Valid work permit (LMIA / employer-specific / open)" },
  { value: "pgwp", label: "Post-graduation work permit (PGWP)" },
  { value: "study_permit", label: "Valid study permit" },
];

export const CONNECTION_TYPES = [
  { value: "relative", short: "Close relative (citizen or PR)", label: "Close relative (parent, sibling, child, grandparent, aunt/uncle, cousin) who is a citizen or PR" },
  { value: "friend", short: "Friend or distant relative", label: "Friend or distant relative living there" },
  { value: "work", short: "Previous work experience", label: "Previous work experience there" },
  { value: "study", short: "Previous study", label: "Previous study there" },
  { value: "lived", short: "Lived there / spouse's tie", label: "Lived there previously / spouse's connection" },
  { value: "other", short: "Other connection", label: "Other connection" },
];
export const CONNECTION_LABELS = Object.fromEntries(CONNECTION_TYPES.map((c) => [c.value, c.short]));

export const TEST_TYPES = [
  { value: "ielts", label: "IELTS General", min: 0, max: 9, step: 0.5, ph: "e.g. 7.0" },
  { value: "celpip", label: "CELPIP General", min: 1, max: 12, step: 1, ph: "e.g. 9" },
  { value: "pte", label: "PTE Core", min: 10, max: 90, step: 1, ph: "e.g. 72" },
];
export const TEST_LABELS = Object.fromEntries(TEST_TYPES.map((t) => [t.value, t.label]));

export const FRENCH_TESTS = [
  { value: "clb", label: "Approximate level (no test)" },
  { value: "tef", label: "TEF Canada", ranges: { listening: [0, 699], reading: [0, 699], writing: [0, 699], speaking: [0, 699] }, ph: { listening: "e.g. 462", reading: "e.g. 462", writing: "e.g. 472", speaking: "e.g. 494" } },
  { value: "tcf", label: "TCF Canada", ranges: { listening: [0, 699], reading: [0, 699], writing: [0, 20], speaking: [0, 20] }, ph: { listening: "e.g. 503", reading: "e.g. 499", writing: "e.g. 12", speaking: "e.g. 12" } },
];
export const FRENCH_TEST_LABELS = Object.fromEntries(FRENCH_TESTS.map((t) => [t.value, t.label]));

export const ON_REGIONS = [
  { value: "", label: "Select region…" },
  { value: "toronto", label: "City of Toronto" },
  { value: "gta", label: "Greater Toronto Area (Durham, Halton, Peel, York)" },
  { value: "central", label: "Central Ontario (Dufferin, Grey, Simcoe, Waterloo, Wellington)" },
  { value: "eastern", label: "Eastern Ontario (Ottawa, Kingston, Peterborough…)" },
  { value: "southwestern", label: "Southwestern Ontario (Hamilton, London, Windsor, Niagara…)" },
  { value: "northern", label: "Northern Ontario (Sudbury, Thunder Bay, Muskoka…)" },
];

export const BC_REGIONS = [
  { value: "", label: "Select area…" },
  { value: "metro_vancouver", label: "Area 1 – Metro Vancouver" },
  { value: "area2", label: "Area 2 – Squamish, Abbotsford, Agassiz, Mission, Chilliwack" },
  { value: "area3", label: "Area 3 – Rest of B.C. (Victoria, Kelowna, Kamloops, Prince George…)" },
];

export const REGIONS_BY_PROVINCE = { ON: ON_REGIONS, BC: BC_REGIONS };
